var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"flex-column":"","fill-height":"","justify-center":"","no-wrap":""}},[_c('notification-message',{staticClass:"notificationMessage"}),_c('SignIn')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }